import React from 'react'
import { Text, View } from '@react-pdf/renderer'
import { Delegator } from '@evertel/schema-parser'

interface ListItem {
    items?: any[]
    [key: string]: any
}

interface ListReadWidgetProps {
    value?: any[]
    title?: string
    description?: string
    item?: ListItem
    items?: any[]
    schemaId?: number
}

const ListReadWidget: React.FC<ListReadWidgetProps> = ({
    value: subForms = [],
    title,
    description,
    item,
    items,
    schemaId
}) => {

    const listItems = (item) ? item.items : items // backwards campatibility

    return (
        <View>
            <Text style={{
                fontSize: 12,
                fontWeight: 'heavy',
                ...(!description && { marginBottom: 10 })
            }}>
                {title}
            </Text>
            {!!description && (
                <Text style={{
                    color: '#999999',
                    fontSize: 9,
                    fontStyle: 'italic',
                    marginBottom: 10
                }}>
                    {description}
                </Text>
            )}
            {(subForms?.length === 0) && (
                <Text style={{ fontSize: 10, color: '#666666' }}>
                    No {title} items added.
                </Text>
            )}
            {subForms.map(({_id, ...itemValue}, subformIndex) =>
                <View
                    key={`v-${subformIndex}`}
                    style={{
                        width: '100%',
                        borderWidth: 1,
                        borderColor: '#cccccc',
                        borderRadius: 8,
                        padding: 15,
                        marginTop: (subformIndex > 0) ? 10 : 0
                    }}>
                    {listItems?.map((listItem, itemIndex) =>
                        <Delegator
                            key={`listWidget-${itemIndex}`}
                            value={itemValue}
                            index={`${subformIndex}-${itemIndex}`}
                            schemaId={schemaId}
                            {...listItem}
                        />
                    )}
                </View>
            )}
        </View>
    )
}

export default ListReadWidget
